import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/pro-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { MonitoringStatus } from 'enum'

import styles from './StateMonitor.module.scss'

interface IStateProps {
  state: MonitoringStatus
  finishedLessons?: number
  totalLessons?: number
  className?: string
}

const StateMonitor: React.FC<IStateProps> = ({
  state,
  className = '',
  finishedLessons = 0,
  totalLessons = 0,
}) => {
  const { t } = useTranslation()
  const translateEnrolState = MonitoringStatus[Number(state)].toLowerCase()
  const stateStyles = [styles.pending, styles.inProgress, styles.finish]
  const icon = () => {
    return (
      <FontAwesomeIcon icon={faCircle} className={stateStyles[Number(state)]} />
    )
  }
  return (
    <div>
      <div
        className={`d-flex align-items-center text-truncate ${styles.stateContainer} ${className}`}
      >
        {icon()}
        <p className={styles.state}>
          {' '}
          {t(`administration.monitor.states.${translateEnrolState}`)}
        </p>
      </div>
      {(!!finishedLessons || !!totalLessons) && (
        <div className={styles.lessons}>
          {t(`administration.monitor.finishedLessons`, {
            finished: finishedLessons,
            total: totalLessons,
          })}
        </div>
      )}
    </div>
  )
}

export default StateMonitor
